import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiJavascript1,
  DiReact,
  DiGitBranch,
  DiNodejsSmall,
  DiNodejs,
} from "react-icons/di";
import {
  SiMongodb,
  SiHtml5,
  SiTypescript,
  SiTailwindcss,
  SiMysql,
  SiNextdotjs,
  SiNodedotjs,
} from "react-icons/si";
import { TbBrandCpp } from "react-icons/tb";
import { FaCss3Alt, FaNodeJs } from "react-icons/fa";
import { BiLogoNodejs, BiLogoPostgresql } from "react-icons/bi";
import { GrGraphQl } from "react-icons/gr";
// import { RiNextjsFill } from "react-icons/ri";


const Techstack = () => {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <TbBrandCpp />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiHtml5 />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <FaCss3Alt />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiTailwindcss />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiNodedotjs/>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiTypescript />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiReact />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiNextdotjs />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiNodejs />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <BiLogoPostgresql />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMongodb />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMysql />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <GrGraphQl />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiGitBranch />
      </Col>
    </Row>
  );
}

export default Techstack;
